import { makeStyles, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';

const useStyles = makeStyles({
  textField: {
    marginRight: '10px',
  },
});
const MoneyInput = ({ setDirty, setValue, value = '', ...props }) => {
  const classes = useStyles();
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(Number.parseFloat(value).toFixed(2)); // sync if parent updates value
  }, [value]);

  const handleFocus = (event) => event.target.select();
  const onChange = (event) => {
    const raw = event.target.value;
    const parsed = raw ? Number.parseFloat(raw) : '';
    setLocalValue(parsed);
    setDirty(true);
  };

  const onBlur = (event) => {
    const raw = event.target.value;
    setLocalValue(Number.parseFloat(raw).toFixed(2));
    const parsed = raw ? Number.parseFloat(raw) : '';
    // only trigger if value actually changed
    if (parsed !== value) {
      setValue(parsed);
    }
  };
  return (
    <TextField
      {...props}
      value={localValue}
      onFocus={handleFocus}
      className={classes.textField}
      onChange={onChange}
      onBlur={onBlur}
      type="number"
      step=".01"
    />
  );
};

export default MoneyInput;
